import { updateSuccessSectionCompany } from "api/Finances";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useUpdateSuccessCompany = () => {
    const queryClient = useQueryClient();
    return useMutation(updateSuccessSectionCompany, {
        onSuccess: () => {
            toast.success("Section updated sucesfully");
            queryClient.invalidateQueries('monthlySuccess');
        },
        onError: () => {
            toast.error("Something went wrong! Please try again later.");
        },
    })
}